(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Sugerecia-producto-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function obtenerIdDrawer() {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return null;
    return cartDrawerEl.id && cartDrawerEl.id.length > 0 ? cartDrawerEl.id : 'cart-drawer';
  }

  function obtenerIdIconoBubble() {
    var iconBubble = document.getElementById('cart-icon-bubble');
    if (iconBubble && iconBubble.id) return iconBubble.id;
    return 'cart-icon-bubble';
  }

  function refrescarDrawerConHtml(html) {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl || !html) return false;
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var nuevoDrawer = doc.querySelector('cart-drawer');
    if (!nuevoDrawer) return false;
    cartDrawerEl.innerHTML = nuevoDrawer.innerHTML;
    if (nuevoDrawer.classList.contains('is-empty')) {
      cartDrawerEl.classList.add('is-empty');
    } else {
      cartDrawerEl.classList.remove('is-empty');
    }
    return true;
  }

  function refrescarIconoConHtml(html) {
    if (!html) return;
    var iconBubble = document.getElementById('cart-icon-bubble');
    if (!iconBubble) return;
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var nuevoIcono = doc.getElementById('cart-icon-bubble');
    if (nuevoIcono) {
      iconBubble.innerHTML = nuevoIcono.innerHTML;
    }
  }

  function forzarAperturaDrawer(cartDrawerEl) {
    if (typeof cartDrawerEl.open === 'function') {
      cartDrawerEl.open();
    } else {
      cartDrawerEl.classList.add('active', 'animate');
      document.body.classList.add('overflow-hidden');
    }
  }

  function abrirCartDrawer(sectionsHtml, idDrawer, idIcono) {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return;

    var actualizado = false;
    if (sectionsHtml && sectionsHtml[idDrawer]) {
      actualizado = refrescarDrawerConHtml(sectionsHtml[idDrawer]);
    }

    if (sectionsHtml && sectionsHtml[idIcono]) {
      refrescarIconoConHtml(sectionsHtml[idIcono]);
    }

    if (actualizado) {
      forzarAperturaDrawer(cartDrawerEl);
      return;
    }

    fetch(window.location.pathname + '?sections=' + encodeURIComponent(idDrawer))
      .then(function (respuesta) {
        return respuesta.json();
      })
      .then(function (datosRespaldo) {
        if (datosRespaldo && datosRespaldo[idDrawer]) {
          refrescarDrawerConHtml(datosRespaldo[idDrawer]);
        }
      })
      .catch(function () {})
      .finally(function () {
        forzarAperturaDrawer(cartDrawerEl);
      });
  }

  function agregarAlCarritoYAbrirDrawer(variantId, alTerminar) {
    var idDrawer = obtenerIdDrawer() || 'cart-drawer';
    var idIcono = obtenerIdIconoBubble();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: idDrawer + ',' + idIcono,
        sections_url: window.location.pathname
      })
    })
      .then(function (respuesta) {
        return respuesta.json();
      })
      .then(function (datos) {
        if (datos && datos.status) {
          if (alTerminar) alTerminar(false);
          return;
        }
        abrirCartDrawer(datos.sections, idDrawer, idIcono);
        if (alTerminar) alTerminar(true);
      })
      .catch(function () {
        if (alTerminar) alTerminar(false);
      });
  }

  document.querySelectorAll('[data-explora-timco]').forEach(function (seccion) {
    var contenedorSugeridos = seccion.querySelector('[data-grid-productos-sugeridos]');
    var cantidadEscritorio = parseInt(seccion.getAttribute('data-cantidad-recientes-escritorio'), 10) || 9;
    var cantidadMovil = parseInt(seccion.getAttribute('data-cantidad-recientes-movil'), 10) || 6;
    var mqEscritorio = window.matchMedia('(min-width: 990px)');

    function aplicarLimiteResponsivo() {
      if (!contenedorSugeridos) return;
      var limite = mqEscritorio.matches ? cantidadEscritorio : cantidadMovil;
      var items = contenedorSugeridos.querySelectorAll('.explora-timco__producto-reciente');
      items.forEach(function (item, indice) {
        item.classList.toggle('explora-timco__producto-reciente--oculto', indice >= limite);
      });
    }

    if (typeof mqEscritorio.addEventListener === 'function') {
      mqEscritorio.addEventListener('change', aplicarLimiteResponsivo);
    } else if (typeof mqEscritorio.addListener === 'function') {
      mqEscritorio.addListener(aplicarLimiteResponsivo);
    }

    aplicarLimiteResponsivo();

    seccion.addEventListener('click', function (evento) {
      var boton = evento.target.closest('[data-agregar-carrito-explora]');
      if (!boton) return;

      evento.preventDefault();
      evento.stopPropagation();

      if (boton.disabled) return;
      if (boton.classList.contains('explora-timco__producto-reciente-boton-agregar--cargando')) return;
      var variantId = boton.getAttribute('data-variant-id');
      if (!variantId) return;

      boton.classList.add('explora-timco__producto-reciente-boton-agregar--cargando');

      agregarAlCarritoYAbrirDrawer(variantId, function () {
        boton.classList.remove('explora-timco__producto-reciente-boton-agregar--cargando');
      });
    });

    var slidesCategorias = seccion.querySelectorAll('[data-categoria-slide]');
    var velocidadSlideshow = parseInt(seccion.getAttribute('data-velocidad-slideshow-categorias'), 10) || 4500;
    var indiceSlideActivo = 0;
    var temporizadorSlideshow = null;

    function mostrarSlide(indice) {
      slidesCategorias.forEach(function (slide, i) {
        slide.classList.toggle('explora-timco__categoria-slide--activa', i === indice);
      });
    }

    function iniciarSlideshowCategorias() {
      if (temporizadorSlideshow || slidesCategorias.length < 2) return;
      temporizadorSlideshow = setInterval(function () {
        indiceSlideActivo = (indiceSlideActivo + 1) % slidesCategorias.length;
        mostrarSlide(indiceSlideActivo);
      }, velocidadSlideshow);
    }

    function detenerSlideshowCategorias() {
      if (temporizadorSlideshow) {
        clearInterval(temporizadorSlideshow);
        temporizadorSlideshow = null;
      }
    }

    function sincronizarSlideshowCategorias() {
      if (mqEscritorio.matches) {
        iniciarSlideshowCategorias();
      } else {
        detenerSlideshowCategorias();
      }
    }

    if (typeof mqEscritorio.addEventListener === 'function') {
      mqEscritorio.addEventListener('change', sincronizarSlideshowCategorias);
    } else if (typeof mqEscritorio.addListener === 'function') {
      mqEscritorio.addListener(sincronizarSlideshowCategorias);
    }

    sincronizarSlideshowCategorias();

    var videosAutoplayExplora = seccion.querySelectorAll('video[data-autoplay-en-vista]');
    if (videosAutoplayExplora.length) {
      videosAutoplayExplora.forEach(function (video) {
        video.muted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;
        video.setAttribute('playsinline', '');
      });

      if ('IntersectionObserver' in window) {
        function iniciarObservadorVideoExplora() {
          var observadorVideoExplora = new IntersectionObserver(function (entradas) {
            entradas.forEach(function (entrada) {
              var video = entrada.target;
              var debeAutoreproducir = video.getAttribute('data-autoplay-en-vista') === 'true';
              if (!debeAutoreproducir) return;

              if (entrada.isIntersecting) {
                if (video.readyState === 0) {
                  video.load();
                }
                var promesa = video.play();
                if (promesa && promesa.catch) {
                  promesa.catch(function () {});
                }
              } else {
                video.pause();
              }
            });
          }, { threshold: 0.25 });

          videosAutoplayExplora.forEach(function (video) {
            observadorVideoExplora.observe(video);
          });
        }

        if (document.readyState === 'complete') {
          iniciarObservadorVideoExplora();
        } else {
          window.addEventListener('load', iniciarObservadorVideoExplora);
        }
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aliados-timco"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sliders = document.querySelectorAll('.aliados-timco-slider');
    sliders.forEach(function(slider) {
      var contenedor = slider.closest('.aliados-timco-contenedor');
      var scroll = slider.querySelector('[data-aliados-timco-scroll]');
      var prev = slider.querySelector('[data-aliados-timco-prev]');
      var next = slider.querySelector('[data-aliados-timco-next]');
      var puntosContenedor = contenedor ? contenedor.querySelector('[data-aliados-timco-puntos]') : null;
      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-aliados-timco-slide]'));
      if (!scroll || slides.length === 0) return;

      var puntos = [];
      if (puntosContenedor) {
        puntos = slides.map(function(_, indice) {
          var punto = document.createElement('button');
          punto.type = 'button';
          punto.className = 'aliados-timco-punto';
          punto.setAttribute('aria-label', 'Ir a la tarjeta ' + (indice + 1));
          punto.addEventListener('click', function() {
            slides[indice].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          });
          puntosContenedor.appendChild(punto);
          return punto;
        });
        if (puntos.length > 0) puntos[0].classList.add('activo');
      }

      function marcarActivo(indice) {
        puntos.forEach(function(punto, i) {
          punto.classList.toggle('activo', i === indice);
        });
      }

      if (puntos.length > 0 && 'IntersectionObserver' in window) {
        var observerSlides = new IntersectionObserver(function(entradas) {
          entradas.forEach(function(entrada) {
            if (entrada.isIntersecting) {
              var indice = slides.indexOf(entrada.target);
              if (indice > -1) marcarActivo(indice);
            }
          });
        }, { root: scroll, threshold: 0.6 });
        slides.forEach(function(slide) { observerSlides.observe(slide); });
      }

      function desplazar(direccion) {
        var ancho = slides[0].getBoundingClientRect().width + 12;
        scroll.scrollBy({ left: direccion * ancho, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function() { desplazar(-1); pausarTemporalmente(); });
      if (next) next.addEventListener('click', function() { desplazar(1); pausarTemporalmente(); });

      var autoplayActivo = slider.getAttribute('data-aliados-timco-autoplay') === 'true';
      var velocidad = parseInt(slider.getAttribute('data-aliados-timco-velocidad'), 10) || 4000;
      var temporizador = null;
      var pausado = false;

      function avanzarAutomatico() {
        if (pausado) return;
        var maximoScroll = scroll.scrollWidth - scroll.clientWidth - 4;
        if (scroll.scrollLeft >= maximoScroll) {
          scroll.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          desplazar(1);
        }
      }

      function iniciarAutoplay() {
        if (!autoplayActivo) return;
        detenerAutoplay();
        temporizador = window.setInterval(avanzarAutomatico, velocidad);
      }

      function detenerAutoplay() {
        if (temporizador) {
          window.clearInterval(temporizador);
          temporizador = null;
        }
      }

      function pausarTemporalmente() {
        pausado = true;
        detenerAutoplay();
        window.setTimeout(function() {
          pausado = false;
          iniciarAutoplay();
        }, velocidad * 2);
      }

      if (autoplayActivo) {
        slider.addEventListener('mouseenter', function() { pausado = true; detenerAutoplay(); });
        slider.addEventListener('mouseleave', function() { pausado = false; iniciarAutoplay(); });
        scroll.addEventListener('touchstart', function() { pausado = true; detenerAutoplay(); }, { passive: true });
        scroll.addEventListener('touchend', function() { pausarTemporalmente(); }, { passive: true });

        if ('IntersectionObserver' in window) {
          var observerAutoplay = new IntersectionObserver(function(entradas) {
            entradas.forEach(function(entrada) {
              if (entrada.isIntersecting) {
                iniciarAutoplay();
              } else {
                detenerAutoplay();
              }
            });
          }, { threshold: 0.3 });
          observerAutoplay.observe(slider);
        } else {
          iniciarAutoplay();
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-flash"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secciones = document.querySelectorAll('[data-oferta-carrusel]');

  secciones.forEach(function (seccion) {
    var slides = seccion.querySelectorAll('[data-slide]');
    var indicadores = seccion.querySelectorAll('[data-indicador]');
    var indiceActual = 0;
    var velocidad = parseInt(seccion.getAttribute('data-autoplay-velocidad'), 10) || 5000;
    var temporizadorAutoplay = null;
    var intervalosRotativos = [];
    var ofertaExpirada = false;

    function irASlide(indice) {
      if (slides.length === 0) return;
      slides[indiceActual].classList.remove('oferta-carrusel__slide--activo');
      if (indicadores[indiceActual]) {
        indicadores[indiceActual].classList.remove('oferta-carrusel__indicador--activo');
      }
      indiceActual = (indice + slides.length) % slides.length;
      slides[indiceActual].classList.add('oferta-carrusel__slide--activo');
      if (indicadores[indiceActual]) {
        indicadores[indiceActual].classList.add('oferta-carrusel__indicador--activo');
      }
    }

    function iniciarAutoplay() {
      if (temporizadorAutoplay) clearInterval(temporizadorAutoplay);
      if (slides.length < 2 || ofertaExpirada) return;
      temporizadorAutoplay = setInterval(function () {
        irASlide(indiceActual + 1);
      }, velocidad);
    }

    indicadores.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var indice = parseInt(boton.getAttribute('data-indice'), 10);
        irASlide(indice);
        iniciarAutoplay();
      });
    });

    seccion.addEventListener('mouseenter', function () {
      if (temporizadorAutoplay) clearInterval(temporizadorAutoplay);
    });
    seccion.addEventListener('mouseleave', iniciarAutoplay);

    iniciarAutoplay();

    var velocidadRotativo = parseInt(seccion.getAttribute('data-velocidad-rotativo'), 10) || 2500;

    slides.forEach(function (slideEl) {
      var textosRotativos = slideEl.querySelectorAll('[data-texto-rotativo]');
      var indiceRotativo = 0;

      if (textosRotativos.length > 1) {
        var idIntervalo = setInterval(function () {
          var indiceAnterior = indiceRotativo;
          indiceRotativo = (indiceRotativo + 1) % textosRotativos.length;
          textosRotativos[indiceAnterior].classList.remove('oferta-carrusel__titulo-rotativo-item--activo');
          textosRotativos[indiceAnterior].classList.add('oferta-carrusel__titulo-rotativo-item--saliente');
          textosRotativos[indiceRotativo].classList.add('oferta-carrusel__titulo-rotativo-item--activo');
          setTimeout(function () {
            textosRotativos[indiceAnterior].classList.remove('oferta-carrusel__titulo-rotativo-item--saliente');
          }, 550);
        }, velocidadRotativo);
        intervalosRotativos.push(idIntervalo);
      }
    });

    var anoFin = parseInt(seccion.getAttribute('data-fecha-ano'), 10) || 2026;
    var mesFin = parseInt(seccion.getAttribute('data-fecha-mes'), 10) || 1;
    var diaFin = parseInt(seccion.getAttribute('data-fecha-dia'), 10) || 1;
    var horaFin = parseInt(seccion.getAttribute('data-fecha-hora'), 10) || 0;
    var minutoFin = parseInt(seccion.getAttribute('data-fecha-minuto'), 10) || 0;
    var segundoFin = parseInt(seccion.getAttribute('data-fecha-segundo'), 10) || 0;
    var tiempoObjetivo = new Date(anoFin, mesFin - 1, diaFin, horaFin, minutoFin, segundoFin).getTime();

    var nodosDias = seccion.querySelectorAll('[data-dias]');
    var nodosHoras = seccion.querySelectorAll('[data-horas]');
    var nodosMinutos = seccion.querySelectorAll('[data-minutos]');
    var nodosSegundos = seccion.querySelectorAll('[data-segundos]');

    function dosDigitos(numero) {
      return numero < 10 ? '0' + numero : String(numero);
    }

    function marcarOfertaExpirada() {
      if (ofertaExpirada) return;
      ofertaExpirada = true;
      seccion.classList.add('oferta-carrusel--expirada');

      if (temporizadorAutoplay) {
        clearInterval(temporizadorAutoplay);
        temporizadorAutoplay = null;
      }

      intervalosRotativos.forEach(function (id) {
        clearInterval(id);
      });
    }

    function actualizarTemporizador() {
      var restante = Math.round((tiempoObjetivo - Date.now()) / 1000);

      if (restante <= 0) {
        restante = 0;
        marcarOfertaExpirada();
      }

      var d = Math.floor(restante / 86400);
      var h = Math.floor((restante % 86400) / 3600);
      var m = Math.floor((restante % 3600) / 60);
      var s = restante % 60;

      nodosDias.forEach(function (nodo) {
        nodo.textContent = dosDigitos(d);
      });
      nodosHoras.forEach(function (nodo) {
        nodo.textContent = dosDigitos(h);
      });
      nodosMinutos.forEach(function (nodo) {
        nodo.textContent = dosDigitos(m);
      });
      nodosSegundos.forEach(function (nodo) {
        nodo.textContent = dosDigitos(s);
      });
    }

    actualizarTemporizador();
    setInterval(actualizarTemporizador, 1000);

    var botonesComprar = seccion.querySelectorAll('[data-comprar-ahora]');
    botonesComprar.forEach(function (boton) {
      boton.addEventListener('click', function () {
        if (ofertaExpirada) return;
        if (boton.classList.contains('oferta-carrusel__boton-comprar--cargando')) return;
        var variantId = boton.getAttribute('data-variant-id');
        var textoSpan = boton.querySelector('[data-texto-boton-comprar]');
        var textoOriginal = textoSpan ? textoSpan.textContent : '';
        if (!variantId) return;

        boton.classList.add('oferta-carrusel__boton-comprar--cargando');
        if (textoSpan) textoSpan.textContent = 'Agregando...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (respuesta) {
            return respuesta.json();
          })
          .then(function (datos) {
            if (datos && datos.status) {
              boton.classList.remove('oferta-carrusel__boton-comprar--cargando');
              if (textoSpan) textoSpan.textContent = 'No disponible';
              setTimeout(function () {
                if (textoSpan) textoSpan.textContent = textoOriginal;
              }, 1800);
              return;
            }
            window.location.href = '/checkout';
          })
          .catch(function () {
            boton.classList.remove('oferta-carrusel__boton-comprar--cargando');
            if (textoSpan) textoSpan.textContent = 'Error';
            setTimeout(function () {
              if (textoSpan) textoSpan.textContent = textoOriginal;
            }, 1800);
          });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contacto-timco"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var contenedores = document.querySelectorAll('[data-contacto-timco-contador]');
    contenedores.forEach(function(contenedor) {
      var valorEl = contenedor.querySelector('[data-contacto-timco-contador-valor]');
      if (!valorEl) return;
      var target = parseInt(valorEl.getAttribute('data-target'), 10) || 0;
      var animado = false;

      function animar() {
        if (animado) return;
        animado = true;
        var inicio = null;
        var duracion = 1600;
        function paso(timestamp) {
          if (!inicio) inicio = timestamp;
          var progreso = Math.min((timestamp - inicio) / duracion, 1);
          var facilitado = 1 - Math.pow(1 - progreso, 3);
          valorEl.textContent = Math.floor(facilitado * target);
          if (progreso < 1) {
            window.requestAnimationFrame(paso);
          } else {
            valorEl.textContent = target;
          }
        }
        window.requestAnimationFrame(paso);
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entradas) {
          entradas.forEach(function(entrada) {
            if (entrada.isIntersecting) {
              animar();
              observer.unobserve(contenedor);
            }
          });
        }, { threshold: 0.4 });
        observer.observe(contenedor);
      } else {
        animar();
      }
    });
  })();

  (function() {
    var sliders = document.querySelectorAll('[data-contacto-timco-resenas]');
    sliders.forEach(function(slider) {
      var scroll = slider.querySelector('[data-contacto-timco-resenas-scroll]');
      var prev = slider.querySelector('[data-contacto-timco-resenas-prev]');
      var next = slider.querySelector('[data-contacto-timco-resenas-next]');
      var puntosContenedor = slider.querySelector('[data-contacto-timco-resenas-puntos]');
      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-contacto-timco-resena-slide]'));
      if (!scroll || slides.length === 0) return;

      var puntos = slides.map(function(_, indice) {
        var punto = document.createElement('button');
        punto.type = 'button';
        punto.className = 'contacto-timco-resenas-punto';
        punto.setAttribute('aria-label', 'Ir a la reseña ' + (indice + 1));
        punto.addEventListener('click', function() {
          slides[indice].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        puntosContenedor.appendChild(punto);
        return punto;
      });
      if (puntos.length > 0) puntos[0].classList.add('activo');

      function marcarActivo(indice) {
        puntos.forEach(function(punto, i) {
          punto.classList.toggle('activo', i === indice);
        });
      }

      if ('IntersectionObserver' in window) {
        var observerSlides = new IntersectionObserver(function(entradas) {
          entradas.forEach(function(entrada) {
            if (entrada.isIntersecting) {
              var indice = slides.indexOf(entrada.target);
              if (indice > -1) marcarActivo(indice);
            }
          });
        }, { root: scroll, threshold: 0.6 });
        slides.forEach(function(slide) { observerSlides.observe(slide); });
      }

      function desplazar(direccion) {
        var ancho = slides[0].getBoundingClientRect().width + 14;
        scroll.scrollBy({ left: direccion * ancho, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function() { desplazar(-1); });
      if (next) next.addEventListener('click', function() { desplazar(1); });
    });
  })();
  (function() {
    var videos = document.querySelectorAll('[data-contacto-timco-instagram-video]');
    if (videos.length > 0 && 'IntersectionObserver' in window) {
      var observerVideos = new IntersectionObserver(function(entradas) {
        entradas.forEach(function(entrada) {
          if (entrada.isIntersecting) {
            entrada.target.play().catch(function() {});
          } else {
            entrada.target.pause();
          }
        });
      }, { threshold: 0.6 });
      videos.forEach(function(video) { observerVideos.observe(video); });
    }
  })();

  (function() {
    var grids = document.querySelectorAll('[data-contacto-timco-instagram-grid]');
    grids.forEach(function(grid) {
      var puntosContenedor = grid.parentElement.querySelector('[data-contacto-timco-instagram-puntos]');
      var items = Array.prototype.slice.call(grid.querySelectorAll('[data-contacto-timco-instagram-item]'));
      if (!puntosContenedor || items.length === 0) return;

      var puntos = items.map(function(_, indice) {
        var punto = document.createElement('button');
        punto.type = 'button';
        punto.className = 'contacto-timco-instagram-punto';
        punto.setAttribute('aria-label', 'Ir a la publicación ' + (indice + 1));
        punto.addEventListener('click', function() {
          items[indice].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
        puntosContenedor.appendChild(punto);
        return punto;
      });
      if (puntos.length > 0) puntos[0].classList.add('activo');

      function marcarActivo(indice) {
        puntos.forEach(function(punto, i) {
          punto.classList.toggle('activo', i === indice);
        });
      }

      if ('IntersectionObserver' in window) {
        var observerItems = new IntersectionObserver(function(entradas) {
          entradas.forEach(function(entrada) {
            if (entrada.isIntersecting) {
              var indice = items.indexOf(entrada.target);
              if (indice > -1) marcarActivo(indice);
            }
          });
        }, { root: grid, threshold: 0.6 });
        items.forEach(function(item) { observerItems.observe(item); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cupon-secret"] && !Shopify.designMode) return;
  try {
    
(function () {
  function dosDigitos(numero) {
    return numero < 10 ? '0' + numero : String(numero);
  }

  function mostrarToast(seccion, texto) {
    var toast = seccion.querySelector('[data-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cupon-timco__toast';
      toast.setAttribute('data-toast', '');
      seccion.appendChild(toast);
    }
    toast.textContent = texto;
    toast.classList.add('cupon-timco__toast--visible');
    clearTimeout(toast._temporizador);
    toast._temporizador = setTimeout(function () {
      toast.classList.remove('cupon-timco__toast--visible');
    }, 2500);
  }

  document.querySelectorAll('[data-cupon-timco]').forEach(function (seccion) {
    var pista = seccion.querySelector('[data-pista]');
    var slides = seccion.querySelectorAll('[data-slide]');
    var indicadores = seccion.querySelectorAll('[data-indicador]');
    var flechaIzquierda = seccion.querySelector('[data-flecha-izquierda]');
    var flechaDerecha = seccion.querySelector('[data-flecha-derecha]');
    var autoplayActivo = seccion.getAttribute('data-autoplay') === 'true';
    var velocidadAutoplay = parseInt(seccion.getAttribute('data-velocidad-autoplay'), 10) || 6000;
    var rutaDestino = seccion.getAttribute('data-ruta-destino') || '/cart';
    var textoRedirigiendo = seccion.getAttribute('data-texto-redirigiendo') || 'Cupón aplicado, redirigiendo...';
    var temporizadorAutoplay = null;
    var usuarioInteractuo = false;

    var prefiereMovimientoReducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    seccion.querySelectorAll('.cupon-timco__video').forEach(function (video) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
    });

    if (!prefiereMovimientoReducido && 'IntersectionObserver' in window) {
      function iniciarObservadorVideoCupon() {
        var observadorVideo = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            var video = entrada.target;
            if (entrada.isIntersecting) {
              if (video.readyState === 0) {
                video.load();
              }
              var promesa = video.play();
              if (promesa && promesa.catch) {
                promesa.catch(function () {});
              }
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.5 });

        seccion.querySelectorAll('.cupon-timco__video').forEach(function (video) {
          observadorVideo.observe(video);
        });
      }

      if (document.readyState === 'complete') {
        iniciarObservadorVideoCupon();
      } else {
        window.addEventListener('load', iniciarObservadorVideoCupon);
      }
    }

    function actualizarEstado() {
      if (!pista || !slides.length) return;
      var anchoSlide = slides[0].getBoundingClientRect().width + 14;
      var maxScroll = pista.scrollWidth - pista.clientWidth;

      if (flechaIzquierda) flechaIzquierda.disabled = pista.scrollLeft <= 4;
      if (flechaDerecha) flechaDerecha.disabled = pista.scrollLeft >= maxScroll - 4;

      var indiceActual = Math.round(pista.scrollLeft / anchoSlide);
      indicadores.forEach(function (indicador, i) {
        indicador.classList.toggle('cupon-timco__indicador--activo', i === indiceActual);
      });
    }

    function desplazar(direccion) {
      if (!pista || !slides.length) return;
      var anchoSlide = slides[0].getBoundingClientRect().width + 14;
      pista.scrollBy({ left: direccion * anchoSlide, behavior: 'smooth' });
    }

    function irAIndice(indice) {
      if (!pista || !slides.length) return;
      var anchoSlide = slides[0].getBoundingClientRect().width + 14;
      pista.scrollTo({ left: indice * anchoSlide, behavior: 'smooth' });
    }

    function detenerAutoplayPermanente() {
      usuarioInteractuo = true;
      if (temporizadorAutoplay) {
        clearInterval(temporizadorAutoplay);
        temporizadorAutoplay = null;
      }
    }

    function iniciarAutoplay() {
      if (!autoplayActivo || slides.length < 2 || usuarioInteractuo || !pista) return;
      temporizadorAutoplay = setInterval(function () {
        var maxScroll = pista.scrollWidth - pista.clientWidth;
        if (pista.scrollLeft >= maxScroll - 4) {
          pista.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          desplazar(1);
        }
      }, velocidadAutoplay);
    }

    if (flechaIzquierda) {
      flechaIzquierda.addEventListener('click', function () {
        desplazar(-1);
        detenerAutoplayPermanente();
      });
    }

    if (flechaDerecha) {
      flechaDerecha.addEventListener('click', function () {
        desplazar(1);
        detenerAutoplayPermanente();
      });
    }

    indicadores.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var indice = parseInt(boton.getAttribute('data-indice'), 10);
        irAIndice(indice);
        detenerAutoplayPermanente();
      });
    });

    if (pista) {
      pista.addEventListener('scroll', function () {
        window.requestAnimationFrame(actualizarEstado);
      }, { passive: true });
      pista.addEventListener('touchstart', detenerAutoplayPermanente, { passive: true });
      pista.addEventListener('wheel', detenerAutoplayPermanente, { passive: true });
      pista.addEventListener('mousedown', detenerAutoplayPermanente);
    }

    window.addEventListener('resize', actualizarEstado);
    actualizarEstado();
    iniciarAutoplay();

    function reclamarCupon(tarjeta) {
      if (tarjeta.classList.contains('cupon-timco__tarjeta--cargando')) return;
      var slide = tarjeta.closest('[data-slide]');
      if (slide && slide.classList.contains('cupon-timco__slide--expirado')) return;

      var codigo = tarjeta.getAttribute('data-codigo');
      if (!codigo) return;

      tarjeta.classList.add('cupon-timco__tarjeta--cargando');
      mostrarToast(seccion, textoRedirigiendo);

      setTimeout(function () {
        window.location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=' + encodeURIComponent(rutaDestino);
      }, 700);
    }

    seccion.querySelectorAll('[data-tarjeta-cupon]').forEach(function (tarjeta) {
      tarjeta.addEventListener('click', function () {
        reclamarCupon(tarjeta);
      });
      tarjeta.addEventListener('keydown', function (evento) {
        if (evento.key === 'Enter' || evento.key === ' ') {
          evento.preventDefault();
          reclamarCupon(tarjeta);
        }
      });
    });

    seccion.querySelectorAll('[data-copiar-codigo]').forEach(function (boton) {
      boton.addEventListener('click', function (evento) {
        evento.stopPropagation();
        var slide = boton.closest('[data-slide]');
        if (slide && slide.classList.contains('cupon-timco__slide--expirado')) return;
        var codigo = boton.getAttribute('data-codigo');
        if (!codigo) return;

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(function () {
            mostrarToast(seccion, 'Código copiado: ' + codigo);
          });
        }
      });
    });

    var anoFin = parseInt(seccion.getAttribute('data-fecha-ano'), 10) || 2026;
    var mesFin = parseInt(seccion.getAttribute('data-fecha-mes'), 10) || 1;
    var diaFin = parseInt(seccion.getAttribute('data-fecha-dia'), 10) || 1;
    var horaFin = parseInt(seccion.getAttribute('data-fecha-hora'), 10) || 0;
    var minutoFin = parseInt(seccion.getAttribute('data-fecha-minuto'), 10) || 0;
    var segundoFin = parseInt(seccion.getAttribute('data-fecha-segundo'), 10) || 0;
    var tiempoObjetivo = new Date(anoFin, mesFin - 1, diaFin, horaFin, minutoFin, segundoFin).getTime();

    var nodosDias = seccion.querySelectorAll('[data-dias]');
    var nodosHoras = seccion.querySelectorAll('[data-horas]');
    var nodosMinutos = seccion.querySelectorAll('[data-minutos]');
    var nodosSegundos = seccion.querySelectorAll('[data-segundos]');

    if (nodosDias.length || nodosHoras.length || nodosMinutos.length || nodosSegundos.length) {
      function actualizarTemporizador() {
        var restante = Math.round((tiempoObjetivo - Date.now()) / 1000);
        if (restante < 0) restante = 0;

        var d = Math.floor(restante / 86400);
        var h = Math.floor((restante % 86400) / 3600);
        var m = Math.floor((restante % 3600) / 60);
        var s = restante % 60;

        nodosDias.forEach(function (nodo) { nodo.textContent = dosDigitos(d); });
        nodosHoras.forEach(function (nodo) { nodo.textContent = dosDigitos(h); });
        nodosMinutos.forEach(function (nodo) { nodo.textContent = dosDigitos(m); });
        nodosSegundos.forEach(function (nodo) { nodo.textContent = dosDigitos(s); });

        if (restante <= 0) {
          slides.forEach(function (slide) {
            slide.classList.add('cupon-timco__slide--expirado');
          });
        }
      }

      actualizarTemporizador();
      setInterval(actualizarTemporizador, 1000);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function construir(root, track, firstSet, velocidadBase) {
    var copiasExistentes = track.querySelectorAll('[data-marquee-set]');
    var anchoSet = firstSet.getBoundingClientRect().width;
    var anchoContenedor = root.clientWidth;

    if (anchoSet <= 0 || anchoContenedor <= 0) return;

    for (var i = 1; i < copiasExistentes.length; i++) {
      copiasExistentes[i].parentNode.removeChild(copiasExistentes[i]);
    }

    var anchoNecesario = anchoContenedor * 2;
    var totalCopias = Math.max(2, Math.ceil(anchoNecesario / anchoSet));

    var fragmentoBase = document.createDocumentFragment();
    for (var j = 1; j < totalCopias; j++) {
      fragmentoBase.appendChild(firstSet.cloneNode(true));
    }
    track.appendChild(fragmentoBase);

    var anchoUnaVuelta = totalCopias * anchoSet;

    var fragmentoDuplicado = document.createDocumentFragment();
    var hijosActuales = Array.prototype.slice.call(track.children);
    hijosActuales.forEach(function (nodo) {
      fragmentoDuplicado.appendChild(nodo.cloneNode(true));
    });
    track.appendChild(fragmentoDuplicado);

    var duracion = (anchoUnaVuelta / anchoSet) * velocidadBase;

    track.style.setProperty('--marquee-distance', '-' + anchoUnaVuelta + 'px');
    track.style.animationDuration = duracion + 's';
    root.classList.add('marquee-is-animating');
  }

  function initMarquee(root) {
    var track = root.querySelector('[data-marquee-track]');
    var firstSet = root.querySelector('[data-marquee-set]');
    if (!track || !firstSet) return;

    var velocidadBase = parseFloat(root.getAttribute('data-marquee-speed')) || 25;

    function programarConstruccion() {
      var ejecutar = function () {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(function () {
            construir(root, track, firstSet, velocidadBase);
          }, { timeout: 800 });
        } else {
          window.requestAnimationFrame(function () {
            construir(root, track, firstSet, velocidadBase);
          });
        }
      };

      if (document.readyState === 'complete') {
        ejecutar();
      } else {
        window.addEventListener('load', ejecutar);
      }
    }

    var imagenes = firstSet.querySelectorAll('img');
    var pendientes = imagenes.length;

    if (pendientes === 0) return;

    imagenes.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        pendientes -= 1;
        if (pendientes === 0) programarConstruccion();
      } else {
        img.addEventListener('load', function () {
          pendientes -= 1;
          if (pendientes === 0) programarConstruccion();
        });
        img.addEventListener('error', function () {
          pendientes -= 1;
          if (pendientes === 0) programarConstruccion();
        });
      }
    });

    var temporizadorResize;
    window.addEventListener('resize', function () {
      clearTimeout(temporizadorResize);
      temporizadorResize = setTimeout(function () {
        construir(root, track, firstSet, velocidadBase);
      }, 200);
    });
  }

  document.querySelectorAll('[data-marquee-root]').forEach(initMarquee);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ofertas-bloque"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secciones = document.querySelectorAll('[data-ofertas-destacadas]');

  function obtenerIdDrawer() {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return 'cart-drawer';
    return cartDrawerEl.id && cartDrawerEl.id.length > 0 ? cartDrawerEl.id : 'cart-drawer';
  }

  function obtenerIdIconoBubble() {
    var iconBubble = document.getElementById('cart-icon-bubble');
    if (iconBubble && iconBubble.id) return iconBubble.id;
    return 'cart-icon-bubble';
  }

  function refrescarDrawerConHtml(html) {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl || !html) return false;
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var nuevoDrawer = doc.querySelector('cart-drawer');
    if (!nuevoDrawer) return false;
    cartDrawerEl.innerHTML = nuevoDrawer.innerHTML;
    if (nuevoDrawer.classList.contains('is-empty')) {
      cartDrawerEl.classList.add('is-empty');
    } else {
      cartDrawerEl.classList.remove('is-empty');
    }
    return true;
  }

  function refrescarIconoConHtml(html) {
    if (!html) return;
    var iconBubble = document.getElementById('cart-icon-bubble');
    if (!iconBubble) return;
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var nuevoIcono = doc.getElementById('cart-icon-bubble');
    if (nuevoIcono) {
      iconBubble.innerHTML = nuevoIcono.innerHTML;
    }
  }

  function forzarAperturaDrawer(cartDrawerEl) {
    if (typeof cartDrawerEl.open === 'function') {
      cartDrawerEl.open();
    } else {
      cartDrawerEl.classList.add('active', 'animate');
      document.body.classList.add('overflow-hidden');
    }
  }

  function abrirCartDrawer(sectionsHtml, idDrawer, idIcono) {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return;

    var actualizado = false;
    if (sectionsHtml && sectionsHtml[idDrawer]) {
      actualizado = refrescarDrawerConHtml(sectionsHtml[idDrawer]);
    }

    if (sectionsHtml && sectionsHtml[idIcono]) {
      refrescarIconoConHtml(sectionsHtml[idIcono]);
    }

    if (actualizado) {
      forzarAperturaDrawer(cartDrawerEl);
      return;
    }

    fetch(window.location.pathname + '?sections=' + encodeURIComponent(idDrawer))
      .then(function (respuesta) {
        return respuesta.json();
      })
      .then(function (datosRespaldo) {
        if (datosRespaldo && datosRespaldo[idDrawer]) {
          refrescarDrawerConHtml(datosRespaldo[idDrawer]);
        }
      })
      .catch(function () {})
      .finally(function () {
        forzarAperturaDrawer(cartDrawerEl);
      });
  }

  function agregarAlCarritoYAbrirDrawer(variantId, alTerminar) {
    var idDrawer = obtenerIdDrawer();
    var idIcono = obtenerIdIconoBubble();

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: idDrawer + ',' + idIcono,
        sections_url: window.location.pathname
      })
    })
      .then(function (respuesta) {
        return respuesta.json();
      })
      .then(function (datos) {
        if (datos && datos.status) {
          if (alTerminar) alTerminar(false);
          return;
        }
        abrirCartDrawer(datos.sections, idDrawer, idIcono);
        if (alTerminar) alTerminar(true);
      })
      .catch(function () {
        if (alTerminar) alTerminar(false);
      });
  }

  function crearAutoplayHorizontal(contenedor, seleccionTarjetas, autoplayActivo, velocidad) {
    var tarjetasLocales = contenedor.querySelectorAll(seleccionTarjetas);
    var temporizador = null;

    function avanzar() {
      if (!tarjetasLocales.length) return;
      var anchoTarjeta = tarjetasLocales[0].getBoundingClientRect().width + 8;
      var maxScroll = contenedor.scrollWidth - contenedor.clientWidth;
      if (contenedor.scrollLeft >= maxScroll - 4) {
        contenedor.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        contenedor.scrollBy({ left: anchoTarjeta, behavior: 'smooth' });
      }
    }

    function iniciar() {
      if (!autoplayActivo || tarjetasLocales.length < 2) return;
      detener();
      temporizador = setInterval(avanzar, velocidad);
    }

    function detener() {
      if (temporizador) {
        clearInterval(temporizador);
        temporizador = null;
      }
    }

    contenedor.addEventListener('touchstart', detener, { passive: true });
    contenedor.addEventListener('touchend', function () {
      setTimeout(iniciar, 2500);
    }, { passive: true });
    contenedor.addEventListener('mouseenter', detener);
    contenedor.addEventListener('mouseleave', iniciar);

    iniciar();
  }

  secciones.forEach(function (seccion) {
    var autoplayActivo = seccion.getAttribute('data-autoplay') === 'true';
    var velocidadAutoplay = parseInt(seccion.getAttribute('data-velocidad-autoplay'), 10) || 3500;

    var pista = seccion.querySelector('[data-pista]');
    var flechaIzquierda = seccion.querySelector('[data-flecha-izquierda]');
    var flechaDerecha = seccion.querySelector('[data-flecha-derecha]');
    var indicadores = seccion.querySelectorAll('[data-indicador]');
    var tarjetas = seccion.querySelectorAll('[data-tarjeta]');

    if (pista) {
      var temporizadorAutoplay = null;

      var actualizarEstado = function () {
        var maxScroll = pista.scrollWidth - pista.clientWidth;

        if (flechaIzquierda) {
          flechaIzquierda.disabled = pista.scrollLeft <= 4;
        }
        if (flechaDerecha) {
          flechaDerecha.disabled = pista.scrollLeft >= maxScroll - 4;
        }

        if (indicadores.length && tarjetas.length) {
          var anchoTarjeta = tarjetas[0].getBoundingClientRect().width + 14;
          var indiceActual = Math.round(pista.scrollLeft / anchoTarjeta);
          indicadores.forEach(function (indicador, i) {
            indicador.classList.toggle('ofertas-destacadas__indicador--activo', i === indiceActual);
          });
        }
      };

      var desplazar = function (direccion) {
        if (!tarjetas.length) return;
        var anchoTarjeta = tarjetas[0].getBoundingClientRect().width + 14;
        var cantidadVisible = Math.max(1, Math.floor(pista.clientWidth / anchoTarjeta));
        pista.scrollBy({ left: direccion * anchoTarjeta * cantidadVisible, behavior: 'smooth' });
      };

      var iniciarAutoplay = function () {
        if (!autoplayActivo || tarjetas.length < 2) return;
        detenerAutoplay();
        temporizadorAutoplay = setInterval(function () {
          var maxScroll = pista.scrollWidth - pista.clientWidth;
          if (pista.scrollLeft >= maxScroll - 4) {
            pista.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            desplazar(1);
          }
        }, velocidadAutoplay);
      };

      var detenerAutoplay = function () {
        if (temporizadorAutoplay) {
          clearInterval(temporizadorAutoplay);
          temporizadorAutoplay = null;
        }
      };

      if (flechaIzquierda) {
        flechaIzquierda.addEventListener('click', function () {
          desplazar(-1);
          detenerAutoplay();
          iniciarAutoplay();
        });
      }

      if (flechaDerecha) {
        flechaDerecha.addEventListener('click', function () {
          desplazar(1);
          detenerAutoplay();
          iniciarAutoplay();
        });
      }

      pista.addEventListener('scroll', function () {
        window.requestAnimationFrame(actualizarEstado);
      }, { passive: true });

      window.addEventListener('resize', actualizarEstado);
      actualizarEstado();

      seccion.addEventListener('mouseenter', detenerAutoplay);
      seccion.addEventListener('mouseleave', iniciarAutoplay);
      pista.addEventListener('touchstart', detenerAutoplay, { passive: true });
      pista.addEventListener('touchend', function () {
        setTimeout(iniciarAutoplay, 2500);
      }, { passive: true });

      iniciarAutoplay();
    }

    var esModoFilaCompacta = window.matchMedia('(max-width: 639px) and (orientation: portrait)').matches;
    var miniSliderPista = seccion.querySelector('[data-mini-slider-pista]');

    if (miniSliderPista && esModoFilaCompacta) {
      crearAutoplayHorizontal(miniSliderPista, '[data-item-compacto]', autoplayActivo, velocidadAutoplay);
    } else if (miniSliderPista && !esModoFilaCompacta) {
      var itemsCompactos = miniSliderPista.querySelectorAll('[data-item-compacto]');
      var visibleCount = Math.min(3, itemsCompactos.length);
      var indiceMini = 0;
      var temporizadorMini = null;

      var medirYAjustarMini = function () {
        if (!itemsCompactos.length) return null;
        var estiloPista = window.getComputedStyle(miniSliderPista);
        var gap = parseFloat(estiloPista.rowGap) || parseFloat(estiloPista.gap) || 8;
        var alturaItem = itemsCompactos[0].getBoundingClientRect().height;
        var contenedor = miniSliderPista.parentElement;
        if (contenedor && alturaItem > 0) {
          contenedor.style.height = (alturaItem * visibleCount + gap * (visibleCount - 1)) + 'px';
        }
        return { alturaItem: alturaItem, gap: gap };
      };

      var moverMini = function () {
        var medidas = medirYAjustarMini();
        if (!medidas || medidas.alturaItem <= 0) return;
        var paso = medidas.alturaItem + medidas.gap;
        var maxIndice = Math.max(0, itemsCompactos.length - visibleCount);
        indiceMini = indiceMini + 1 > maxIndice ? 0 : indiceMini + 1;
        miniSliderPista.style.transform = 'translateY(-' + (indiceMini * paso) + 'px)';
      };

      var iniciarMini = function () {
        detenerMini();
        if (itemsCompactos.length > visibleCount) {
          temporizadorMini = setInterval(moverMini, velocidadAutoplay);
        }
      };

      var detenerMini = function () {
        if (temporizadorMini) {
          clearInterval(temporizadorMini);
          temporizadorMini = null;
        }
      };

      medirYAjustarMini();
      window.addEventListener('resize', medirYAjustarMini);
      seccion.addEventListener('touchstart', detenerMini, { passive: true });
      seccion.addEventListener('touchend', function () {
        setTimeout(iniciarMini, 2500);
      }, { passive: true });

      iniciarMini();
    }

    var botonesCarrito = seccion.querySelectorAll('[data-agregar-carrito]');
    botonesCarrito.forEach(function (boton) {
      boton.addEventListener('click', function () {
        if (boton.classList.contains('ofertas-destacadas__boton-carrito--cargando')) return;
        var variantId = boton.getAttribute('data-variant-id');
        var textoSpan = boton.querySelector('[data-texto-boton]');
        var textoOriginal = textoSpan ? textoSpan.textContent : '';
        if (!variantId) return;

        boton.classList.add('ofertas-destacadas__boton-carrito--cargando');
        if (textoSpan) textoSpan.textContent = 'Agregando...';

        agregarAlCarritoYAbrirDrawer(variantId, function (exito) {
          boton.classList.remove('ofertas-destacadas__boton-carrito--cargando');
          if (!exito) {
            if (textoSpan) textoSpan.textContent = 'Error';
          } else if (textoSpan) {
            textoSpan.textContent = textoOriginal;
          }
          if (!exito) {
            setTimeout(function () {
              if (textoSpan) textoSpan.textContent = textoOriginal;
            }, 1800);
          }
        });
      });
    });

    var botonesCarritoCompacto = seccion.querySelectorAll('[data-agregar-carrito-compacto]');
    botonesCarritoCompacto.forEach(function (boton) {
      boton.addEventListener('click', function (evento) {
        evento.preventDefault();
        evento.stopPropagation();

        if (boton.classList.contains('ofertas-destacadas__item-compacto-boton-agregar--cargando')) return;
        var variantId = boton.getAttribute('data-variant-id');
        if (!variantId) return;

        boton.classList.add('ofertas-destacadas__item-compacto-boton-agregar--cargando');

        agregarAlCarritoYAbrirDrawer(variantId, function () {
          boton.classList.remove('ofertas-destacadas__item-compacto-boton-agregar--cargando');
        });
      });
    });

    var botonComprarAhora = seccion.querySelector('[data-comprar-ahora]');
    if (botonComprarAhora) {
      botonComprarAhora.addEventListener('click', function () {
        if (botonComprarAhora.classList.contains('ofertas-destacadas__boton-grande--cargando')) return;
        var variantId = botonComprarAhora.getAttribute('data-variant-id');
        var textoSpan = botonComprarAhora.querySelector('[data-texto-boton-grande]');
        var textoOriginal = textoSpan ? textoSpan.textContent : '';
        if (!variantId) return;

        botonComprarAhora.classList.add('ofertas-destacadas__boton-grande--cargando');
        if (textoSpan) textoSpan.textContent = 'Agregando...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (respuesta) {
            return respuesta.json();
          })
          .then(function (datos) {
            if (datos && datos.status) {
              botonComprarAhora.classList.remove('ofertas-destacadas__boton-grande--cargando');
              if (textoSpan) textoSpan.textContent = 'No disponible';
              setTimeout(function () {
                if (textoSpan) textoSpan.textContent = textoOriginal;
              }, 1800);
              return;
            }
            window.location.href = '/checkout';
          })
          .catch(function () {
            botonComprarAhora.classList.remove('ofertas-destacadas__boton-grande--cargando');
            if (textoSpan) textoSpan.textContent = 'Error';
            setTimeout(function () {
              if (textoSpan) textoSpan.textContent = textoOriginal;
            }, 1800);
          });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
